import React from "react";
import { TextField, Typography } from "@mui/material";

interface FileInputProps {
    size?: "small" | "medium";
    type?: string;
    label: string;
    name: string;
    error?: boolean;
    helperText?: string | false;
    productSlug?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Fileinput: React.FC<FileInputProps> = ({
    size = "medium",
    type = "file",
    label,
    name,
    error,
    helperText,
    productSlug,
    onChange,
}) => {
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        const isShriram = productSlug?.toLowerCase() === "shri_ram";

        if (file) {
            const allowedFileTypes = isShriram
                ? ["application/pdf", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    "image/png"]
                : ["application/pdf", "image/jpeg", "image/png", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                ];

            // ❌ Invalid file type
            if (!allowedFileTypes.includes(file.type)) {
                e.target.value = "";
                alert(
                    isShriram
                        ? "Allowed formats: .pdf, .xlsx, .png only."
                        : "Allowed formats: .pdf, .jpg, .png only."
                );
                return;
            }

            // ❌ File too large (> 2MB)
            if (file.size > 2 * 1024 * 1024) {
                e.target.value = "";
                alert("File size exceeds 2MB.");
                return;
            }
        }

        // ✅ Pass to parent formik handler
        onChange(e);
    };

    const fileAccept =
        productSlug?.toLowerCase() === "shri_ram"
            ? ".pdf,.xlsx,.png"
            : ".pdf,.jpg,.png,.xlsx";

    return (
        <>
            <TextField
                size={size}
                type={type}
                label={label}
                name={name}
                fullWidth
                InputLabelProps={{ shrink: true }}
                inputProps={{ accept: fileAccept }}
                error={error}
                helperText={helperText}
                onChange={handleFileChange}
            />
        </>
    );
};

export default Fileinput;
